/* import __COLOCATED_TEMPLATE__ from './sharing-data-card.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import type AppService from 'embercom/services/app-service';
import type Store from '@ember-data/store';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type ModelTrainingConsentOptOutRequest from 'embercom/models/model-training-consent-opt-out-request';

interface SharingDataCardSignature {
  Args: {
    dataSharingOptOut: ModelTrainingConsentOptOutRequest | null | undefined;
  };
}

export default class SharingDataCard extends Component<SharingDataCardSignature> {
  @service declare appService: AppService;
  @service declare notificationsService: any;
  @service declare intl: any;
  @service declare store: Store;
  @tracked isProcessing = false;

  @action
  async confirmOptOut() {
    if (this.isProcessing) {
      return;
    }

    this.isProcessing = true;
    let optOutRequest: ModelTrainingConsentOptOutRequest;

    // If no opt-out request exists, create one
    if (!this.args.dataSharingOptOut) {
      optOutRequest = this.store.createRecord('model-training-consent-opt-out-request', {
        appId: this.appService.app.id,
        approved: false,
      }) as ModelTrainingConsentOptOutRequest;
    } else {
      optOutRequest = this.args.dataSharingOptOut;
    }

    try {
      optOutRequest.optOutReason = 'User requested opt-out';

      await optOutRequest.save();

      this.notificationsService.notifyConfirmation(
        this.intl.t(
          'new-settings.workspace.security.models-data-sharing.sharing-data-card.opt-out-success',
        ),
      );
    } catch (error) {
      console.error('Failed to save opt-out request:', error);
      this.notificationsService.notifyError(
        this.intl.t(
          'new-settings.workspace.security.models-data-sharing.sharing-data-card.opt-out-error',
        ),
      );
    } finally {
      this.isProcessing = false;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::SecurityModelsDataSharing::SharingDataCard': typeof SharingDataCard;
  }
}
